import { Ds, VisuallyHidden } from "@accurx/design";

type PreviewSummaryTemplateProps = {
    note: string;
    messageSummary: string;
};

export const PreviewSummaryTemplate = ({
    note,
    messageSummary,
}: PreviewSummaryTemplateProps) => {
    return (
        <>
            <Ds.Text as="span" size="small" weight="bold">
                <VisuallyHidden as="span">Responded by </VisuallyHidden>
                {note}:{" "}
            </Ds.Text>
            <Ds.Text as="span" size="small">
                <VisuallyHidden as="span">Message summary: </VisuallyHidden>
                {messageSummary}
            </Ds.Text>
        </>
    );
};
